<template>

  <div>
    <PrescriptionPopup @closePrescriptionPopupEv="closePrescriptionPopup" :prescription_id="currentPrescription" v-if="displayPrescriptionPopup" />
  <div v-for="(order_item, index) in cart_items" :key="order_item.id" >
    <b-row class="order-item"  >
        <div class="order-item-content">
          <div class="product-image">
            <div class="image product-img" v-if="order_item.glass_variation" >
              <img class="product-img-inner" :src="calculatePhotoSimple(order_item.glass_variation.photos.split(']')[0])" />
            </div>
            <CartImage v-else :cart_item="order_item" />
          </div>
          <div class="product-details">
            <div class="product-name">{{order_item.glass.name}}</div>
            <div class="product-quantity">Size: <template v-if="order_item.size">{{order_item.size.toUpperCase()}}</template><template v-else>Custom fit</template></div>
            <div class="product-quantity">Quantity: {{order_item.quantity}}</div>
           
            <template v-if="order_item.glass_variation">
              <div>Color: {{order_item.glass_variation.color.name}} (ref : {{order_item.glass_variation.color.supplier_reference}})</div>
              <div v-if="order_item.glass_option">
                Lens technology: {{order_item.glass_option.name}}
              </div>
              <div>Lens Tint: {{order_item.glass_variation.tint.name}} (ref : {{order_item.glass_variation.tint.supplier_reference}})</div>
              <div v-if="order_item.glass_type">
                Lens type: {{order_item.glass_type.name}}
              </div>
              </template>
              <template v-for="order_item_customization in order_item.order_item_customizations">
                  <div v-if="order_item_customization.model_part.type=='color' && order_item_customization.model_part.render_type=='face'">
                    Color {{order_item_customization.model_part.name}}: {{order_item_customization.color.name}} (ref : {{order_item_customization.color.supplier_reference}})
                  </div>
                  <div v-else-if="order_item_customization.model_part.type=='texture_color' && order_item_customization.model_part.render_type=='face'">
                    Color {{order_item_customization.model_part.name}}: {{order_item_customization.color.name}} (ref : {{order_item_customization.color.supplier_reference}})
                  </div>
                
                </template>
                <template v-for="order_item_customization in order_item.order_item_customizations">
                  <div v-if="order_item_customization.model_part.type=='color' && order_item_customization.model_part.render_type=='branch'">
                    Color {{order_item_customization.model_part.name}}: {{order_item_customization.color.name}} (ref : {{order_item_customization.color.supplier_reference}})
                  </div>
                  <div v-else-if="order_item_customization.model_part.type=='texture_color' && order_item_customization.model_part.render_type=='branch'">
                    Color {{order_item_customization.model_part.name}}: {{order_item_customization.color.name}} (ref : {{order_item_customization.color.supplier_reference}})
                   
                  </div>
                <!-- <span v-if="order_item_customization.model_part.render_type=='lense'">Teinte de verres : {{order_item_customization.tint ? order_item_customization.tint.name : "Aucune"}}<br /></span> -->
                </template>

                <div v-if="order_item.tint">Lens tint: {{order_item.tint.name}} (ref : {{order_item.tint.supplier_reference}})
              </div>

            <div class="badges">
              <div class="little-badge" @click="displayPrescription(order_item.prescription.id)" v-if="order_item.prescription!=null"><img src="@/assets/images/doc.svg" />{{order_item.prescription.name}}</div>
              <div class="little-badge" @click="($user.optical_scan_measurements_access==true || $user.other_scan_measurements_access==true) ? $router.push({name:!$isAdmin ? 'scanReview': 'scanDetail', params: { id: order_item.scan.id }}) : null" v-if="order_item.scan!=null"><img src="@/assets/images/scan.svg" />{{order_item.scan.name}}</div>
            </div>

            <template v-if="order.address">

            <template v-if="order.address.pupillary_height || order.address.left_pupillary_height || order.address.right_pupillary_height || order.address.pupillary_distance || order.address.left_pupillary_distance || order.address.right_pupillary_distance">
              <br /><span class="product-name">Optical informations:</span>

              <table class="table prescription-table">
                <tr>
                    <td></td>
                    <td><center>Right eye (OD)</center></td>
                    <td><center>Left eye (OG)</center></td>

                </tr>

                <tr>
                
                  <td>Pupillary distance</td>
                  <template v-if="order.address.pupillary_distance != '' && order.address.pupillary_distance != null">
                    <td colspan="2"><div class="value">{{(order.address.pupillary_distance!=''&&order.address.pupillary_distance!=null)?order.address.pupillary_distance:'-'}}</div></td>
                  </template>
                  <template v-else>
                    <td><div class="value">{{(order.address.left_pupillary_distance!=''&&order.address.left_pupillary_distance!=null)?order.address.left_pupillary_distance:'-'}}</div></td>
                    <td><div class="value">{{(order.address.right_pupillary_distance!=''&&order.address.right_pupillary_distance!=null)?order.address.right_pupillary_distance:'-'}}</div></td>
                  </template>

                </tr>
                <tr>
                
                <td>Pupillary height</td>
                <template v-if="order.address.pupillary_height != '' && order.address.pupillary_height != null">
                  <td colspan="2"><div class="value">{{(order.address.pupillary_height!=''&&order.address.pupillary_height!=null)?order.address.pupillary_height:'-'}}</div></td>
                </template>
                <template v-else>
                  <td><div class="value">{{(order.address.left_pupillary_height!=''&&order.address.left_pupillary_height!=null)?order.address.left_pupillary_height:'-'}}</div></td>
                  <td><div class="value">{{(order.address.right_pupillary_height!=''&&order.address.right_pupillary_height!=null)?order.address.right_pupillary_height:'-'}}</div></td>
                </template>

              </tr>
              
            </table>

              
            </template>
          </template>
            
          </div>
        </div>
        <div class="subtotal">
          <template v-if="$user.hide_prices!=true">
                  
                  {{order_item.amount}}€
                  </template>
                  <template v-else>On demand</template>
        </div>
        <!--<b-button variant="primary" @click="displayOrderItem(order_item.id)">See more</b-button>-->
      </b-row>
    <b-row v-if="user.stl_files && (order_item.size=='s' || order_item.size=='l' || order_item.size=='xs' || order_item.size=='m' || order_item.size=='xl')"  >
      
      <b-card  class="col-md-12 border mt-1">
        <div class="header-card">
          <div class="title-card">
            <img src="@/assets/images/folders.svg" />
            <span>3D Files</span>
          </div>
          <b-button v-if="order_item.glass.id!=24" variant="info" @click="downloadAll(order_item)" >Download files</b-button>
        </div>

        <template v-if="order_item.size!=null">
          <template v-if="order_item.size=='s' || order_item.size=='l' || order_item.size=='xs' || order_item.size=='m' || order_item.size=='xl' ">
            <template v-if="cart_items.length">

              <b-row class="download-item" >
                <div class="item-left">
                  <div class="image-dl">
                    <img src="@/assets/images/face.png" />
                  </div>
                  <span>Face</span>
                </div>
                <b-button @click="cart_item.glass.id!=24 ? downloadFrame(order_item) : downloadFrameSingle(order_item)" variant="primary">Download</b-button>
              </b-row>
              <b-row class="download-item" v-if="order_item.glass.id!=24">
                <div class="item-left">
                  <div class="image-dl">
                    <img src="@/assets/images/left_temple.png" />
                  </div>
                  <span>Temple left</span>
                </div>
                <b-button :href="'https://api.sens-eye.fr/stl-files/'+calculateStlTempleL(order_item)" variant="primary">Download</b-button>
              </b-row>
              <b-row class="download-item" v-if="order_item.glass.id!=24">
                <div class="item-left">
                  <div class="image-dl">
                    <img src="@/assets/images/right_temple.png" />
                  </div>
                  <span>Temple right</span>
                </div>
                <b-button  :href="'https://api.sens-eye.fr/stl-files/'+calculateStlTempleR(order_item)"  variant="primary">Download</b-button>
              </b-row>
            </template>
          </template>
        </template>
      </b-card>
    </b-row>

    <b-row v-else-if="order_item.scan && ($user.id==1336 || $user.id==1369 || $user.id==1451 || $isAdmin || $user.id==690)" class="order-files-cards-row">
      <template v-if="adjustment_results[index]">
      <b-card  v-if="adjustment_results[index].svg_url" class="border mb-1 mt-1 col-xl-6" >
        <div class="header-card">
          <div class="title-card">
            <img src="@/assets/images/folders.svg" />
            <span>Technical files</span>
          </div>
          
         
        </div>

        
        
          <b-row class="download-item" >
            <div class="item-left">
              <div class="image-dl">
                <img src="@/assets/images/report.jpg" />
              </div>
              <span>Technical file</span>
            </div>
            <b-button :href="adjustment_results[index].svg_url" download target="_blank" variant="primary">Download</b-button>
          </b-row>
          <template v-if="adjustment_results[index] && ($user.id==690 || $isAdmin || $isAdmin || $user.id==1336 || $user.id==1369 || $user.id==1451)">
            <b-button   variant="primary" class="mt-1" @click="displayCustomFit3D(order_item,adjustment_results[index])">View generated 3D file</b-button>
            <br />
            
            <b-button   variant="secondary" class="mt-1" @click="displayCustomFit(order_item)">Generate files again</b-button>
          </template>

         
      </b-card>
    </template>
      <b-card class="border mb-1 mt-1" :class="{'col-xl-6':adjustment_results[index],'col-xl-12':!adjustment_results[index]}">
        <div class="header-card">
          <div class="title-card">
            <img src="@/assets/images/folders.svg" />
            <span>3D Files</span>
          </div>
          <template v-if="!adjustment_results[index]">
            <b-badge variant="test">
              Awaiting fit file</b-badge>
          </template>
          <b-button v-else variant="info " :href="'https://api.sens-eye.fr/api/download-files-3d/'+adjustment_results[index].id" >Download all 3D files</b-button>
      
         
        </div>

        <b-button  v-if="!adjustment_results[index] && ($user.id==690 || $isAdmin || $user.id==1336 || $user.id==1369 || $user.id==1451)" variant="secondary" class="mt-1" @click="displayCustomFit(order_item)">Generate custom fit file</b-button>
       
        <template v-if="adjustment_results[index]">
          <b-row v-if="adjustment_results[index].stl_frame_url" class="download-item" >
            <div class="item-left">
              <div class="image-dl">
                <img src="@/assets/images/face.png" />
              </div>
              <span>Face</span>
            </div>
            <b-button :href="adjustment_results[index].stl_frame_url" variant="primary">Download</b-button>
          </b-row>
          <b-row v-if="adjustment_results[index].stl_temple_left_url" class="download-item" >
            <div class="item-left">
              <div class="image-dl">
                <img src="@/assets/images/templel.png" />
              </div>
              <span>Temple left</span>
            </div>
            <b-button :href="adjustment_results[index].stl_temple_left_url" variant="primary">Download</b-button>
          </b-row>
          <b-row v-if="adjustment_results[index].stl_temple_right_url" class="download-item" >
            <div class="item-left">
              <div class="image-dl">
                <img src="@/assets/images/templer.png" />
              </div>
              <span>Temple right</span>
            </div>
            <b-button :href="adjustment_results[index].stl_temple_right_url" variant="primary">Download</b-button>
          </b-row>
          <!--<b-row v-if="adjustment_results[index].subd_url" class="download-item" >
            <div class="item-left">
              <div class="image-dl">
                <img src="@/assets/images/face.png" />
              </div>
              <span>SubD</span>
            </div>
            <b-button :href="adjustment_results[index].subd_url" variant="primary">Download</b-button>
          </b-row>-->
        </template>

        
         
      </b-card>

     
    </b-row>


    <b-row v-else-if="order_item.scan && !order_item.size && ($user.id==1336 || $user.id==1369 || $user.id==1451 || $isAdmin || $user.id==690)">
      <b-card class="border mb-1 mt-1 col-md-12">
        <div class="header-card">
          <div class="title-card">
            <img src="@/assets/images/folders.svg" />
            <span>Custom fit files</span>
          </div>
          <template v-if="fitting_result_custom_fit[index]">
            <b-button v-if="fitting_result_custom_fit[index].pdf_file" variant="info"  :href="fitting_result_custom_fit[index].pdf_file" >Download PDF</b-button>
          </template>
          <template v-else>
            <b-badge variant="test">
              Awaiting fit file</b-badge>

           
          </template>
         
        </div>

        <b-button  v-if="!fitting_result_custom_fit[index] && ($user.id==690 || $isAdmin || $user.id==1336 || $user.id==1369 || $user.id==1451)" variant="secondary" class="mt-1" @click="displayCustomFit(order_item)">Generate custom fit file</b-button>

        <template v-if="fitting_result_custom_fit[index]">
          <b-row v-if="fitting_result_custom_fit[index].zip_file" class="download-item" >
            <div class="item-left">
              <div class="image-dl">
                <img src="@/assets/images/face.png" />
              </div>
              <span>STL File(s)</span>
            </div>
            <b-button :href="fitting_result_custom_fit[index].zip_file" variant="primary">Download</b-button>
          </b-row>
        </template>
         
      </b-card>

     
    </b-row>


    <b-row v-else-if="$user.color_categories.length>0 && hasColorCategory(order_item)">

      <b-card class="col-md-12 border mt-1">
        <div class="header-card">
          <div class="title-card">
            <img src="@/assets/images/folders.svg" />
            <span>3D Files</span>
          </div>
        </div>

        
          <b-row class="download-item" >
            <div class="item-left">
              <div class="image-dl">
                <img src="@/assets/images/face.png" />
              </div>
              <span>3D Files</span>
            </div>
            <b-button  @click="downloadFiles(order_item)" variant="primary">Download</b-button>
          </b-row>
        
              
         
      </b-card>
      
    </b-row>
    <b-row v-if="$user.fitting_pdf_access==true && order_item.glass.frame_drop_available==true">
  

      <b-card class="border col-md-12 mt-1" v-if="order_item.scan">
        <div class="header-card">
          <div class="title-card">
            <img src="@/assets/images/scans.svg" />
            <span>Personal report</span>
          </div>
          
          <b-button variant="info"   @click="displayCanvasModal()" >Display report</b-button>
          
          <b-modal id="modal-scan-canvas"  size="lg" ok-only> 
            <adjustment-report :pupillary_height="pupillaryHeight[index]" :eye_to_lens_distance="eyeToLensDistance[index]" :scan_id="order_item.scan.id" :order="order" :order_item="order_item" />
          </b-modal>
         
        </div>

      </b-card>


    </b-row>
   

    <CustomFitPopup @applyAdjustmentResultEv="applyAdjustmentResult" :order_item="currentOrderItem" @closeCustomFitPopupEv="displayCustomFitPopup=false" :fittingResult="fittingResult" v-if="displayCustomFitPopup" />


      
    </div>
  </div>
</template>


<script>
import CartImage from "./CartImageComponent.vue";
import {BModal, BButton,BOverlay, VBModal, BRow, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Auth} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ScanPopup from '../../components/ScanPopup.vue'
import AdjustmentReport from '../order-review/AdjustmentReport.vue'
import PrescriptionPopup from '../prescription/PrescriptionPopup.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import emitter from 'tiny-emitter/instance'
import CustomFitPopup from './CustomFitPopup.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    CartImage,
    BAvatar,
    BOverlay,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    BRow,
    ScanPopup,
    PrescriptionPopup,
    AdjustmentReport,
    CustomFitPopup
  },
  props:['order',"cart_items","photos","eyeToLensDistance","pupillaryHeight","user","fitting_results","fitting_result_custom_fit"],
  data() {
    return {
      fittingResult:null,
      currentOrderItem:null,
      showLogs:false,
      displayPrescriptionPopup:false,
    
      displayStatusSelection:false,
      statusSelected:"canceled",
      statusOptions:['dispatched','failed','delivered','completed', 'canceled', 'printing'],
      pageLength: 10,
      dir: false,
      
      currentScan:null,
      currentPrescription:null,
    
      displayScanPopup:false,
      loading:true,
      trackingNumber:'',
      adjustment_results:[],
      loadingCustomFit:false,
      displayCustomFitPopup:false
    }
  },
  computed: {
    customFitLogs() {
      if (!this.fitting_result_custom_fit) {
        return ''
      }
      const candidates = [
        this.fitting_result_custom_fit.custom_fit_log,
        this.fitting_result_custom_fit.size_selection_log,
        this.fitting_result_custom_fit.fitting_score_log,
        this.fitting_result_custom_fit.alignment_log,
        this.fitting_result_custom_fit.best_iteration_index,
        
      ]

      const normalizedLogs = []
      const sanitizeLog = text => {
        const cleaned = text.replace(/Erreur JSON: Syntax error \| Chaîne nettoyée:\s*/g, '')
        return cleaned.trim() === '' ? null : cleaned
      }

      const normalize = entry => {
        if (entry === undefined || entry === null || entry === '') {
          return
        }
        if (Array.isArray(entry)) {
          entry.forEach(item => normalize(item))
          return
        }
        if (typeof entry === 'object') {
          try {
            const sanitizedObject = sanitizeLog(JSON.stringify(entry, null, 2))
            if (sanitizedObject) {
              normalizedLogs.push(sanitizedObject)
            }
          } catch (error) {
            const sanitizedFallback = sanitizeLog(String(entry))
            if (sanitizedFallback) {
              normalizedLogs.push(sanitizedFallback)
            }
          }
          return
        }
        const sanitizedString = sanitizeLog(String(entry))
        if (sanitizedString) {
          normalizedLogs.push(sanitizedString)
        }
      }

      candidates.forEach(candidate => normalize(candidate))

      return normalizedLogs.join('\n\n')
    },
  },
  methods:{
    applyAdjustmentResult(adjustmentResult) {
      console.log('on reload les')
      this.fittingResult=adjustmentResult
      this.getAdjustmentResults()
    },
    
    displayCustomFit(order_item) {
      this.fittingResult=null
      this.displayCustomFitPopup=true
      this.currentOrderItem=order_item
    },
    displayCustomFit3D(order_item,result) {
      this.fittingResult=result
      this.displayCustomFitPopup=true
      this.currentOrderItem=order_item
    },
    closePrescriptionPopup() {
      this.displayPrescriptionPopup=false
    },
    triggerDownload(url, filename) {
      if (!url || typeof url !== 'string') {
        console.error('Invalid download URL:', url)
        return
      }
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    checkColorCategory(color)
    {
      for(let i=0;i<this.user.color_categories.length;i++)
      {
        for(let j=0;j<this.user.color_categories[i].colors.length;j++)
        {
          if(this.user.color_categories[i].colors[j].id==color.id)
          {
            return true
          }
        }
      }
      return false
    },
    hasColorCategory(order_item)
    {
      for(let i=0;i<order_item.order_item_customizations.length;i++)
      {
        if(order_item.order_item_customizations[i].color)
        {
          if(this.checkColorCategory(order_item.order_item_customizations[i].color))
          {
            return true
          }
        }
      }
      return false

    },
    async generateCustomFitFiles(scan_id)
    {
      let fitting_result = await APIRequest.custom_fit(scan_id)
      this.fitting_result_custom_fit = await APIRequest.detail('fitting-results-custom-fit',fitting_result.id)

    },
    async downloadFiles(order_item)
    {
      if(order_item.scan && !order_item.size)
      {
        await this.generateCustomFitFiles(order_item.scan.id)
        // check pour chaque element si elle est dans la couleur category de l'utilisateur 
        let url1=process.env.VUE_APP_API_URL+'download-zip-full2/'+this.calculateStlTempleLCustomFit()+'/'+this.calculateStlTempleRCustomFit()+'/'+this.calculateStlTempleRTipCustomFit()+'/'+this.calculateStlTempleLTipCustomFit()+'/'+this.calculateStlCustomFit()
     
        this.triggerDownload(url1, "files.zip");

      }
      else if(order_item.size)
      {
        if(order_item.size=="onesize")
        {
          let url2=process.env.VUE_APP_API_URL+'download-zip-full2/'+this.calculateStlTempleLOneSize(order_item)+'/'+this.calculateStlTempleRCustomFit(order_item)+'/'+this.calculateStlTempleRTipCustomFit(order_item)+'/'+this.calculateStlTempleLTipOneSize(order_item)+'/'+this.calculateStlOneSize(order_item)
          this.triggerDownload(url2, "files.zip");
        
        }
        else 
        {
          
          let url2=process.env.VUE_APP_API_URL+'download-zip-full/'+this.calculateStlTempleLSize(order_item)+'/'+this.calculateStlTempleRSize(order_item)+'/'+this.calculateStlTempleRTipSize(order_item)+'/'+this.calculateStlTempleLTipSize(order_item)+'/'+this.calculateStlSize(order_item)
          console.log('UROL')
          console.log(url2)
          this.triggerDownload(url2, "files.zip");
        }
        
      }
    
    },
    calculateStlOneSize(order_item)
    { 
      let url = 'model'+order_item.glass.id+'-Size-OneSize-Face.stl'
      return url
    },
    calculateStlTempleLOneSize(order_item)
    {
      let url = 'model'+order_item.glass.id+'-Size-OneSize-Temple-L.stl'
      return url
    },
    calculateStlTempleROneSize(order_item)
    {
      let url = 'model'+order_item.glass.id+'-Size-OneSize-Temple-R.stl'
      return url
    },
    calculateStlTempleRTipOneSize(order_item)
    {
      let url = 'model'+order_item.glass.id+'-Size-OneSize-Temple-R-Tip.stl'
      return url
    },
    calculateStlTempleLTipOneSize(order_item)
    {
      let url = 'model'+order_item.glass.id+'-Size-OneSize-Temple-L-Tip.stl'
      return url
    },
    calculateStlSize(order_item)
    { 
      let url = 'model'+order_item.glass.id+'-Size-'+order_item.size.toUpperCase()+'-Face.stl'
      return url
    },
    calculateStlTempleLSize(order_item)
    {
      let url = 'model'+order_item.glass.id+'-Size-'+order_item.size.toUpperCase()+'-Temple-L.stl'
      return url
    },
    calculateStlTempleRSize(order_item)
    {
      let url = 'model'+order_item.glass.id+'-Size-'+order_item.size.toUpperCase()+'-Temple-R.stl'
      return url
    },
    calculateStlTempleRTipSize(order_item)
    {
      let url = 'model'+order_item.glass.id+'-Size-'+order_item.size.toUpperCase()+'-Temple-R-Tip.stl'
      return url
    },
    calculateStlTempleLTipSize(order_item)
    {
      let url = 'model'+order_item.glass.id+'-Size-'+order_item.size.toUpperCase()+'-Temple-L-Tip.stl'
      return url
    },

    calculateStlCustomFit() {
      return this.normalizeCustomFitPath(this.fitting_result_custom_fit.export_frame_filename)
    },
    calculateStlTempleLCustomFit() {
      return this.normalizeCustomFitPath(this.fitting_result_custom_fit.export_frame_metal_filename)
    },
    calculateStlTempleRCustomFit() {
      return this.normalizeCustomFitPath(this.fitting_result_custom_fit.export_frame_metal_filename)
    },
    calculateStlTempleRTipCustomFit()
    {
      let url = 'Louis-C-Size-S-Temple-R-Tip.stl'
      return url
    },
    calculateStlTempleLTipCustomFit()
    {
      let url = 'Louis-C-Size-S-Temple-L-Tip.stl'
      return url
    },
    normalizeCustomFitPath(path) {
      if (!path || typeof path !== 'string') {
        return ''
      }
      const prefixPattern = /^C:[/\\]{1,2}webapp[/\\]{1,2}visages-server[/\\]{1,2}data[/\\]{1,2}frames[/\\]{1,2}custom-fit[/\\]{0,2}/i
      const cleaned = path.replace(prefixPattern, '')
      return cleaned.replace(/^[/\\]+/, '')
    },
    calculatePhotoSimple(photo) {
      return photo.replace('[','').replaceAll("'",'')
    },
    displayCanvasModal() {
      this.$bvModal.show("modal-scan-canvas")
    },
   
    calculateStl(order_item)
    {
    
      let url = 'https://api.sens-eye.fr/stl-files/'+order_item.glass.file1+'_frame'

      for(let i=0;i<order_item.order_item_customizations.length;i++)
      {
        if(order_item.order_item_customizations[i].model_part.render_slug=="frame")
        {
          if(order_item.order_item_customizations[i].texture)
          {
            url+='_texturestyle'+order_item.order_item_customizations[i].texture.id
           // url+='-texturestyle'+order_item.order_item_customizations[i].texture.id
          }
          else
          {
            url+='_texturestyle4'
            //url+='-texturestyle4'
          }
          if(order_item.order_item_customizations[i].texture_style)
          {
            url+='_textureposition'+order_item.order_item_customizations[i].texture_style.id
            //url+='-textureposition'+order_item.order_item_customizations[i].texture_style.id
          }
          else
          {
            url+='_textureposition0'
            //url+='-textureposition0'
          }
          
        }
      }
      
      url+='_'+order_item.size
      
      url+='.stl'

      return url
    },
    calculateStlFrame(order_item)
    {
      let url = order_item.glass.file1+'_frame'
      //let url = order_item.glass.file1

      for(let i=0;i<order_item.order_item_customizations.length;i++)
      {
        if(order_item.order_item_customizations[i].model_part.render_slug=="frame")
        {
          if(order_item.order_item_customizations[i].texture)
          {
            url+='_texturestyle'+order_item.order_item_customizations[i].texture.id
            //url+='-texturestyle'+order_item.order_item_customizations[i].texture.id
          }
          else
          {
            url+='_texturestyle4'
            //url+='-texturestyle4'
          }
          if(order_item.order_item_customizations[i].texture_style)
          {
            url+='_textureposition'+order_item.order_item_customizations[i].texture_style.id
            //url+='-textureposition'+order_item.order_item_customizations[i].texture_style.id
          }
          else
          {
            url+='_textureposition0'
            //url+='-textureposition0'
          }
          
        }
      }
      
      url+='_'+order_item.size
      
      url+='.stl'

      return url
    },
    calculateStlTempleR(order_item)
    {
    
      let url = order_item.glass.file1+'_templer'
      //let url = order_item.glass.file1

      for(let i=0;i<order_item.order_item_customizations.length;i++)
      {
        if(order_item.order_item_customizations[i].model_part.render_slug=="temples")
        {
          if(order_item.order_item_customizations[i].texture)
          {
            url+='_texturestyle'+order_item.order_item_customizations[i].texture.id
            //url+='-texturestyle'+order_item.order_item_customizations[i].texture.id
          }
          else
          {
            url+='_texturestyle4'
           // url+='-texturestyle4'
          }
         
          
        }
      }
      
      //url+='-TempleR'
      url+='_'+order_item.size
      
      url+='.stl'

      return url
    },
    calculateStlTempleL(order_item)
    {
    
      let url = order_item.glass.file1+'_templel'
      //let url = order_item.glass.file1

      for(let i=0;i<order_item.order_item_customizations.length;i++)
      {
        if(order_item.order_item_customizations[i].model_part.render_slug=="temples")
        {
          if(order_item.order_item_customizations[i].texture)
          {
         
            url+='_texturestyle'+order_item.order_item_customizations[i].texture.id
           //url+='-texturestyle'+order_item.order_item_customizations[i].texture.id
          }
          else
          {
            url+='_texturestyle4'
            //url+='-texturestyle4'
          }
        
          
        }
      }
     
      //url+='-TempleL'
      url+='_'+order_item.size
      
      url+='.stl'

      return url
    },
    async downloadFile(url, filename) {
      try {
        const response = await fetch(url, {
          
          mode:"no-cors"
          
        });

     
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        saveFile(blobUrl, filename);
        URL.revokeObjectURL(blobUrl);
      } catch (err) {
        console.error("Error in fetching and downloading file:", err);
      }
    },
    downloadFrameSingle(order_item)
    {
      let url3="https://api.sens-eye.fr/api/download-zip-single/"+this.calculateStlFrame(order_item);
      this.triggerDownload(url3, "frame.stl");
      this.setDownloaded()
    },
    downloadFrame(order_item)
    {
      let url3=this.calculateStl(order_item);
      this.triggerDownload(url3, "frame.stl");
      this.setDownloaded()
    },
    async getAdjustmentResults() {
      this.adjustment_results=[]
      for(let i=0;i<this.cart_items.length;i++)
      {
        let adjustment_results = await APIRequest.list_with_request('adjustment-results','?order=desc&order_item='+this.cart_items[i].id+'&limit=1')
        if(adjustment_results.length>0)
        {
          this.adjustment_results.push(adjustment_results[0][0])
        }
        else
        {
          this.adjustment_results.push(null)
        }
      }
      
    },
    downloadAllAdjustment(adjustment_result) {
        console.log(adjustment_result)
        this.triggerDownload(adjustment_result.stl_url, 'model_mesh.stl')
        
        setTimeout(() => {
          this.triggerDownload(adjustment_result.stl_frame_url, 'model.svg')
          setTimeout(() => {
            this.triggerDownload(adjustment_result.stl_temple_left_url, 'model_templel.svg')
            setTimeout(() => {
              this.triggerDownload(adjustment_result.stl_temple_right_url, 'model_templer.svg')
              if(adjustment_result.subd_url)
              {
                setTimeout(() => {
                  this.triggerDownload(adjustment_result.subd_url, 'model_subd.3dm')
                }, 100)
              
           
              }
            }, 100)
          }, 100)
        }, 100)
    },
    downloadAll(order_item)
    {


      let url1='https://api.sens-eye.fr/api/download-zip/'+this.calculateStlTempleL(order_item)+'/'+this.calculateStlTempleR(order_item)+'/'+this.calculateStlFrame(order_item)
     
      this.triggerDownload(url1, "files.zip");

      // //saveAs(blob, "hello world.txt");
       //saveAs(url1, "temple-l.stl");
      // saveAs(url2, "temple-r.stl");
      // saveAs(url3, "frame.stl");
      
      
      // window.open(url1);
      // window.open(url2);
      // window.open(url3);
      this.setDownloaded()

    },
    async setDownloaded() {
      this.loading=true
      let params=this.order
      params.files_downloaded=true
      await APIRequest.update('orders',this.order.id,params)
      this.loading=false
    },
    async saveNote() {
      this.loading=true
      let params=this.order
      await APIRequest.update('orders',this.order.id,params)
      this.loading=false
    },
    displayScan(id) {
      this.currentScan=id
      this.displayScanPopup=true
    },
    displayPrescription(id) {
      this.currentPrescription=id
      this.displayPrescriptionPopup=true
    },
},
  mounted() {
    this.getAdjustmentResults()
  }

}


  </script>

  <style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';

.prescription-table td
  {
    border:0 !important;
   
    padding:10px;
   
    .value 
    {
      background:#f1f1f1;
      padding:10px;
      border-radius: 5px;
      width:100%;
      text-align: center;
    }
  }
  @media (min-width: 1140px) {
   
  
    .order-files-cards-row
    {
      gap: 15px;

      > .card.col-xl-6
      {
        flex: 0 0 calc(50% - 7.5px);
        max-width: calc(50% - 7.5px);
      }
    }
}
.little-badge
{
  display:flex;
  border-radius:5px;
  padding:5px 10px;
  background:#f1f1f1;
  align-items: center;
  gap:5px;
  cursor:pointer;
  font-size:13px;
  color:#000;
  img
  {
    height:16px;
  }
}
.badges
{
  margin-top:10px;
  display:flex;
  gap:5px;
 
}
.product-img-inner {
  width: 100%;

}
.table-align-left td {
  width:50%;
}
.table-align-left
{
  text-align:left !important;
}
.table-align-left td, .table-align-left th
{
  text-align:left !important;
}

.log-block {
  background-color: #1f1f1f;
  color: #f1f1f1;
  padding: 1rem;
  border-radius: 0.5rem;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.85rem;
}
.image-dl
{
  border-radius:5px;
  min-height:72px;
  background:#f1f1f1;
  display:flex;
  justify-content: center;
  align-items: center;
  padding:5px;
}
</style>